import React, { FC } from "react";
import { RadioButtonUnchecked } from "@material-ui/icons";
import TenpoCheckManagerAnalysisOKNGButton from "./TenpoCheckManagerAnalysisOKNGButton";

const TenpoCheckManagerAnalysisOKButton: FC<{
  id: string;
  bigItemId: string;
  smallItemId: string;
  selectedTemplateItemName?: string;
  selectedTemplateItemUuid?: string;
}> = ({ id, bigItemId, smallItemId, selectedTemplateItemName, selectedTemplateItemUuid }) => {
  return (
    <>
      <TenpoCheckManagerAnalysisOKNGButton
        id={id}
        bigItemId={bigItemId}
        smallItemId={smallItemId}
        selectedTemplateItemName={selectedTemplateItemName}
        selectedTemplateItemUuid={selectedTemplateItemUuid}
        icon={<RadioButtonUnchecked style={{ fontSize: "16px" }} />}
      />
    </>
  );
};
export default TenpoCheckManagerAnalysisOKButton;
